// extracted by mini-css-extract-plugin
module.exports = {"checkedInBg":"guest-checkin-info_checkedInBg__1kOp3","checkedOutBg":"guest-checkin-info_checkedOutBg__2a5qf"};